import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-status-user",
  "use": "icon-status-user-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-status-user\"><path d=\"M512 469.333333a213.333333 213.333333 0 0 1 213.333333 213.333334v256H298.666667v-256a213.333333 213.333333 0 0 1 213.333333-213.333334z m-286.378667 128.256a297.941333 297.941333 0 0 0-11.946666 70.4L213.333333 682.666667v256H85.333333v-192a149.333333 149.333333 0 0 1 133.077334-148.48l7.253333-0.597334z m572.757334 0A149.376 149.376 0 0 1 938.666667 746.666667V938.666667h-128v-256c0-29.568-4.266667-58.112-12.288-85.077334zM234.666667 341.333333a106.666667 106.666667 0 1 1 0 213.333334 106.666667 106.666667 0 0 1 0-213.333334z m554.666666 0a106.666667 106.666667 0 1 1 0 213.333334 106.666667 106.666667 0 0 1 0-213.333334zM512 85.333333a170.666667 170.666667 0 1 1 0 341.333334 170.666667 170.666667 0 0 1 0-341.333334z\" p-id=\"2329\" fill=\"#409eed\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/status-user.svg
// module id = jxuZ
// module chunks = 112